import { Component, OnInit, Input, OnChanges, SimpleChanges, SimpleChange } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Constant, BaseComponent, DatePickerFormatter } from '../../../../../../../infrastructure/common/index';
import { OnlineOrderService } from '../../../../../../../infrastructure/services/transaction/op/outbound/order/index';
import { ConfirmDialogModule, ConfirmationService } from 'primeng/primeng';
import { Router } from '@angular/router';

import {
  TicketService,
} from '../../../../../../../infrastructure/services/transaction/op/outbound/ticket/index';

import { ContainerSizeService } from '../../../../../../../infrastructure/services/master/hm/index';
import {
  TruckSizeService,
  TimeSlotService
} from '../../../../../../../infrastructure/services/master/op/index';

import { Ticket } from '../../../../../../../data/models/transaction/op/outbound/ticket/index';

import * as _ from 'lodash';
import * as moment from 'moment';
import { concat } from 'rxjs/observable/concat';

declare var jQuery: any;

@Component({
  selector: 'app-ticket-entry',
  templateUrl: './ticket-entry.component.html',
  providers: [ConfirmationService],
  styleUrls: ['./ticket-entry.component.css']
})

export class TicketEntryComponent extends BaseComponent implements OnInit {
  @Input() ticket: Ticket = new Ticket;
  self = this;
  isUnavailableDateLoading: boolean = false;
  isAccountLoading = false;
  isContainerSizeLoading = false;
  isTruckSizeLoading = false;
  isTimeSlotLoading = false;
  isLoading = false;
  accounts: any[];
  timeSlots: any[];
  containersSize: any[];
  trucksSize: any[];

  unavailableDates: Date[] = [];

  selectedAccount: any;
  vehicleType = Constant.VehicleType;
  bookingType = Constant.BookingType;

  constructor(
    private router: Router,
    private confirmationService: ConfirmationService,
    private onlineOrderService: OnlineOrderService,
    private timeSlotService: TimeSlotService,
    private containerSizeService: ContainerSizeService,
    private TruckSizeService: TruckSizeService,
    private ticketService: TicketService
  ) {
    super();
  }

  ngOnInit() {
    this.loadAccounts();
    this.loadUnavailableDates();
    this.loadAvailableTimeSlot("", "");
    this.loadContainerSize();
    this.loadTruckSize();
    this.setVehicleType(this.vehicleType.container);
  }


  ngAfterViewInit() {

    //console.log(self.unavailableDates);

    var self = this;

    jQuery('.etadate-datepicker').datepicker({
      autoclose: true,
      clearBtn: true,
      format: DatePickerFormatter.mapDateFormat(this.token.DateFormatDescription),
      beforeShowDay: function (date) {

        if (self.isUnavailableDateLoading)
          return false;

        if (self.unavailableDates) {
          for (let i = 0; i < self.unavailableDates.length; i++) {
            let blockedDate = self.unavailableDates[i];
            if (date.toDateString() == blockedDate.toDateString()) {
              return false;
            }
          }
        }

        return true;
      }
    })
      .on('show', (e) => {
        let nextDayTimeDiff = 0;
        let dateDiff = 0;
        let saturday = 6;

        let today = moment();
        let nextDay = moment().startOf('day').add(1, 'days');
        let isSaturday: boolean = today.toDate().getDay() == saturday;

        if (isSaturday) {
          nextDay.add(1, 'days');
        }

        while (self.unavailableDates && self.unavailableDates.map(Number).indexOf(+nextDay) != -1) {
          nextDay.add(1, 'days');
        }

        let startDate = '+1d';

        if (isSaturday) {
          dateDiff = nextDay.diff(today.startOf('day'), 'days');
          startDate = '+' + dateDiff + 'd';
        }
        jQuery('.etadate-datepicker').datepicker('setStartDate', startDate);
      })
      .on('change', (e) => {
        this.ticket.ETADateString = e.target.value;
        this.handleETADateChange(this.ticket.ETADateString);
      });

    jQuery('.lastdate-datepicker').datepicker({
      autoclose: true,
      clearBtn: true,
      format: DatePickerFormatter.mapDateFormat(this.token.DateFormatDescription)
    }).on('show', (e) => {
      let dateDiff = 0;
      let today = moment(new Date());
      let etaDateISOString = moment(self.ticket.ETADateString, self.token.DateFormatDescription.toUpperCase()).toISOString();// moment("28-02-2018","dd-mm-yyyy").toISOString();
      let etaDate =  moment(new Date(etaDateISOString));
      dateDiff = etaDate.diff(today, 'days')+1;

      let startDate = '+'+dateDiff+'d';

      jQuery('.lastdate-datepicker').datepicker('setStartDate', startDate);
    }).on('change', (e) => {
      this.ticket.LastDateString = e.target.value;
    });
  } 

  formResetThenSetDefaultData(form: NgForm): void {
    form.resetForm();
    this.setDefaultAccount(this.accounts);
    this.setVehicleType(this.vehicleType.container);
    jQuery('#VehicleType1').prop('checked', 'checked');
  }

  onSubmitTicket(form: NgForm): void {
    const self = this;

    self.isLoading = true;
    self.ticket.OwnerCode = self.selectedAccount.OwnerCode;
    self.ticket.WarehouseCode = self.token.DefaultWarehouseCode;
    self.ticket.BookingType = self.bookingType.incoming;

    //self.formResetThenSetDefaultData(form);
    self.ticketService.save(self.ticket)
      .subscribe(data => {
        let message = data;

        if (message && message.MessageType && message.MessageType.Value) {
          if (message.MessageType.Value === Constant.MessageType.success) {
            let ticket = message.Result;

            if (ticket) {
              self.formResetThenSetDefaultData(form);
              self.showConfirmationDialog(ticket.OwnerCode, ticket.BookingNo);

            }
          }

          self.isLoading = false;       
        } else {

          self.isLoading = false;
          self.showMessage(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError);
        }
      },
      error => {
        self.isLoading = false;
        self.showMessage(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError, error);
      });


    // self.isLoading = false;

    // self.showConfirmationDialog("BO180013");
  }

  showDatePicker(idEl) {
    jQuery('#' + idEl).datepicker('show');
  }

  setVehicleType(type: string) {
    this.ticket.VehicleType = type;
  }

  handleVehicleTypChange(value) {
    if (value === this.vehicleType.truck) {
      this.ticket.ContainerNo = null;
      this.ticket.ContainerSize = null;
      this.ticket.SealNo = null;
      this.ticket.Transporter = null;
      this.ticket.LastDateString = null;
    } else {
      this.ticket.SupplierName = null;
      this.ticket.TruckSize = null;
      this.ticket.TimeSlot = null;
    }
  }

  handleTruckSizeChange(truckSize) {
    let self = this;

    let etaDateString = self.ticket.ETADateString !== undefined ? self.ticket.ETADateString : '';
    self.loadAvailableTimeSlot(truckSize, etaDateString);

    this.ticket.TimeSlot = null;
  }

  handleETADateChange(etaDateString) {

    let self = this;
    let truckSize = self.ticket.TruckSize !== undefined ? self.ticket.TruckSize : '';
    self.loadAvailableTimeSlot(truckSize, etaDateString);

    this.ticket.TimeSlot = null;
  }

  setDefaultAccount(accounts: any[]): void {

    let self = this;

    self.selectedAccount = _.find(accounts, function (obj) {
      return obj.OwnerCode === self.token.DefaultOwnerCode;
    });
  }

  loadAccounts(): void {
    let self = this;
    this.isAccountLoading = true;

    const groupId = this.token.GroupId;

    this.onlineOrderService.getAuthOwnerCustomerReprecentatives(groupId)
      .subscribe(
      data => {
        let message = data;
        if (message && message.MessageType && message.MessageType.Value) {
          if (message.MessageType.Value === Constant.MessageType.success) {
            this.accounts = message.Result;
            this.setDefaultAccount(this.accounts);
          }
          else {
            self.showAlert(message.MessageType.Value, message.MessageNumber, message.Message, message.AdditionalInformation);
          }
        }
        else {
          self.showAlert(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError, null);
        }
        this.isAccountLoading = false;
      },
      error => {
        self.showAlert(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError, error);
        this.isAccountLoading = false;
      }
      );
  }

  loadContainerSize(): void {
    this.isContainerSizeLoading = true;

    this.containerSizeService.get()
      .subscribe(
      data => {
        let message = data;
        if (message && message.MessageType && message.MessageType.Value) {
          if (message.MessageType.Value == Constant.MessageType.success) {
            this.containersSize = message.Result;
          }
          else {
            this.showAlert(message.MessageType.Value, message.MessageNumber, message.Message, message.AdditionalInformation);
          }
        }
        else {
          this.showAlert(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError, null);
        }
        this.isContainerSizeLoading = false;
      },
      error => {
        this.showAlert(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError, error);
        this.isContainerSizeLoading = false;
      }
      );
  }

  loadTruckSize(): void {
    this.isTruckSizeLoading = true;

    this.TruckSizeService.get()
      .subscribe(
      data => {
        let message = data;
        if (message && message.MessageType && message.MessageType.Value) {
          if (message.MessageType.Value == Constant.MessageType.success) {
            this.trucksSize = message.Result;
          } else {
            this.showAlert(message.MessageType.Value, message.MessageNumber, message.Message, message.AdditionalInformation);
          }
        } else {
          this.showAlert(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError, null);
        }
        this.isTruckSizeLoading = false;
      },
      error => {
        this.showAlert(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError, error);
        this.isTruckSizeLoading = false;
      });
  }

  loadAvailableTimeSlot(truckSize: string, etaDateString: string): void {
    let self = this;

    self.isTimeSlotLoading = true;

    self.timeSlotService.getAvailable(truckSize, etaDateString)
      .subscribe(
      data => {
        let message = data;
        if (message && message.MessageType && message.MessageType.Value) {
          if (message.MessageType.Value === Constant.MessageType.success) {
            self.timeSlots = []; // empty the timeslot first
            self.timeSlots = message.Result;
          } else {
            self.showAlert(message.MessageType.Value, message.MessageNumber, message.Message, message.AdditionalInformation);
          }
        } else {
          self.showAlert(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError, null);
        }
        self.isTimeSlotLoading = false;
      },
      error => {
        self.showAlert(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError, error);
        self.isTimeSlotLoading = false;
      });
  }

  loadUnavailableDates(): void {
    let self = this;

    self.isUnavailableDateLoading = true;

    self.ticketService.getUnavailableDates()
      .subscribe(
      data => {
        self.isUnavailableDateLoading = false;
        let message = data;
        if (message && message.MessageType && message.MessageType.Value) {
          if (message.MessageType.Value === Constant.MessageType.success) {
            let unavailableDates = message.Result;

            unavailableDates.forEach(item => {
              self.unavailableDates.push(new Date(item));
            });
          } else {
            self.showAlert(message.MessageType.Value, message.MessageNumber, message.Message, message.AdditionalInformation);
          }
        } else {
          self.showAlert(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError, null);
        }
      },
      error => {
        self.showAlert(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError, error);
        self.isUnavailableDateLoading = false;
      });
  }

  loadBookingConfirmationReport(ownerCode: string, bookingNo: string): void {
    let self = this;
    this.ticketService.generateTicket(ownerCode, bookingNo).subscribe(
      (data) => {
        var fileURL = URL.createObjectURL(data);
        window.open(fileURL);
      },
      error => {
        self.isLoading = false;
        self.showAlert(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError, error);
      }
    );
  }

  showConfirmationDialog(ownerCode: string, bookingNo: string) {
    let self = this;

    let message = 'Booking No: ' + bookingNo + ' has been successfully created. ' +
      'Would you like to print Booking Confirmation report?';

    this.confirmationService.confirm({
      rejectVisible: true,
      icon: Constant.MessageIcon.success,
      header: Constant.MessageType.success,
      message: message,
      accept: () => {
        self.loadBookingConfirmationReport(ownerCode, bookingNo);
        self.router.navigate(['/pages/ticket-tracking']);
      },
      reject: () => {
        self.router.navigate(['/pages/ticket-tracking']);
      }
    });
  }

  showMessage(title: string, messageNumber: string, message: string, additionalInfo: string = null) {
    jQuery('#PopupMessageTitle').html(title);
    jQuery('#PopupMessageContent').html('(' + messageNumber + ') ' + message + (additionalInfo ? ' -- ' + additionalInfo : ''));
    jQuery('#PopupMessage').modal('show');
  }

  showAlert(title: string, messageNumber: string, message: string, additionalInfo: string = null) {
    alert(title + ': (' + messageNumber + ') ' + message + '--' + (additionalInfo ? ' -- ' + additionalInfo : ''))
  }
}



// WEBPACK FOOTER //
// ./src/app/views/pages/transaction/op/outbound/ticket/ticket-entry/ticket-entry.component.ts